import env from '@env';
import {validVideoFormats} from '@/constants/appConstants';

export const isVideoFormat = ( fileType ) => validVideoFormats.includes( String( fileType ).toLowerCase() );

export const getAssetImageSrc = ( id, {size} = {size: 800} ) =>
    `${env.API_ORIGIN}/assets/image/${id}/${size}`;

export const getAssetDownloadUrl = ( id, scheme = 'image' ) => `${env.API_ORIGIN}/assets/download/${scheme}/${id}`
